module.exports = __webpack_public_path__ + "img/onetwotree4.36127407.jpg";